import { Box, Button, TextField, Grid2 } from "@mui/material"
import { useState } from "react"
import { useAppDispatch } from "../../../app/hooks"
import { getCapitalByDateThunk, getCapitalByDateAndUserThunk } from "../capital-contribute.slice"
import UserSelectorAutocomplete from "./user-selector-autocomplete"

interface CapitalContributeFilterState {
  selectedUserId: string
  selectedDate: string
}

export default function CapitalContributeFilter() {
  const dispatch = useAppDispatch()
  const [filterState, setFilterState] = useState<CapitalContributeFilterState>({
    selectedUserId: "",
    selectedDate: new Date().toISOString().split('T')[0]
  })

  const handleFilterChange = (field: keyof CapitalContributeFilterState, value: string) => {
    setFilterState(prev => ({
      ...prev,
      [field]: value
    }))
  }

  const handleUserChange = (selectedUserId: string) => {
    handleFilterChange('selectedUserId', selectedUserId)
  }

  const handleApplyFilter = () => {
    if (filterState.selectedDate) {
      if (filterState.selectedUserId) {
        dispatch(getCapitalByDateAndUserThunk({ 
          date: filterState.selectedDate, 
          userId: filterState.selectedUserId 
        }))
      } else {
        dispatch(getCapitalByDateThunk({ date: filterState.selectedDate }))
      }
    }
  }

  const handleClearFilter = () => {
    setFilterState({
      selectedUserId: "",
      selectedDate: new Date().toISOString().split('T')[0]
    })
  }

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      gap: 2, 
      mb: 3, 
      p: 3, 
      bgcolor: 'background.paper', 
      borderRadius: 2,
      boxShadow: 1
    }}>
      <Grid2 container spacing={3} alignItems="center">
        <Grid2 size={{xs: 12, md: 6}}>
          <UserSelectorAutocomplete
            selectedUserId={filterState.selectedUserId}
            onUserChange={handleUserChange}
            label="Filtrar por Usuario"
            placeholder="Seleccionar usuario para filtrar..."
          />
        </Grid2>

        <Grid2 size={{xs: 12, md: 3}}>
          <TextField
            label="Fecha"
            type="date"
            value={filterState.selectedDate}
            onChange={(e) => handleFilterChange('selectedDate', e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            fullWidth
          />
        </Grid2>

        <Grid2 size={{xs: 12, md: 3}}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button 
              variant="contained" 
              onClick={handleApplyFilter}
              disabled={!filterState.selectedDate}
              fullWidth
            >
              Filtrar
            </Button>

            <Button 
              variant="outlined" 
              onClick={handleClearFilter}
              fullWidth
            >
              Limpiar
            </Button>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  )
} 